// extracted by mini-css-extract-plugin
export var label = "_kd-2";
export var slideContainer = "_kd-0";
export var slider = "_kd-1";